
export function editButtonForm() {
  return {
    restrict: 'E',
    template: require('./editButtonForm.directive.html'),
    scope: {
      button: '=',
      isDefaultAction: '<',
    },
    controller: controller
  };
}

controller.$inject = ['$scope'];
function controller($scope) {
  // When checking the 'hasDefaultAction' or 'hasButton' checkbox for the first time,
  // we need to initialise the type.
  // At least for the default action, we must set it to web_url as it is the only valid value
  $scope.button = $scope.button || {type: 'web_url'};
} 